import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from 'vue';
import { useDonationFormsStore } from '../store';
import { ElNotification } from 'element-plus';
import descriptor from '../utils/rules'
import ModalView from "./ModalView.vue";

import ModalTemplate from "./ModalTemplate.vue";
import { groupBySlots } from '../utils/helper';


export default /*@__PURE__*/_defineComponent({
  __name: 'Modal',
  props: ['id', 'dstyle'],
  setup(__props, { expose: __expose }) {
  __expose();

const _ = globalThis._;
const store = useDonationFormsStore();
const props = __props;


const submit = () => {
  const { $state } = store;
  store.validate({ rules: descriptor, fields: $state })
    .then((res) => {
      store.submit()
    })
    .catch(({fields, errors}) => {
      validation_catch(fields, errors);
    });
};
const validation_catch = (fields: Record<string, any>, errors: any[]) => {
  _.each(fields, (field) => {
    setTimeout(() => {
      ElNotification({
        type: 'error',
        title: "Error",
        message: field[0].message,
        offset: 40,
      });
    }, 300);
  });
};

onMounted(async() => {
  await store.getData({ vm: props });
  
  if (store.showModal) {
  }
});



const __returned__ = { _, store, props, submit, validation_catch, ModalView, ModalTemplate, get groupBySlots() { return groupBySlots } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})